import { useEffect, useState } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import useFormSubmit from './useFormSubmit';
import { AuthType, FormState, MetricsType, SubmitPayload } from '../types';
import { getValidationSchema, formatErrorsToRedux } from '../helpers';

type PropsType = {
  auth?: AuthType;
  metrics: MetricsType;
  onSuccess?: (payload: SubmitPayload) => void;
};

const useEmailSubscriptionForm = (props: PropsType) => {
  const { onSuccess, auth, metrics } = props;

  const { sendSubscribeToKM, userEmail, LSEmail } = useFormSubmit({ auth, metrics });

  const [time, setTime] = useState(Date.now());
  const [isSuccess, setIsSuccess] = useState(false);

  const validationSchema = getValidationSchema();

  const { handleSubmit, control, reset } = useForm<FormState>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues: { email: LSEmail || userEmail },
  });

  const { isSubmitted, errors } = useFormState({
    control,
  });

  const formattedErrors = formatErrorsToRedux(errors);

  useEffect(() => {
    if (isSubmitted) {
      setTime(Date.now());
    }
  }, [isSubmitted]);

  useEffect(() => {
    if (userEmail) {
      reset({ email: userEmail });
    }
  }, [userEmail]);

  const handleFormSubmit = (data: { email: string }) => {
    const { KMData } = metrics;
    setIsSuccess(true);

    if (onSuccess) {
      onSuccess({
        ...data,
        ...(KMData || {}),
      });
    }

    sendSubscribeToKM(data.email);
  };

  return {
    time,
    setTime,
    control,
    isSubmitted,
    errors: formattedErrors,
    onFormSubmit: handleSubmit(handleFormSubmit),
    isSuccess,
    isHidden: Boolean(LSEmail),
  };
};

export default useEmailSubscriptionForm;
